import type {
	ClientIntakeFormContextItem,
	ClientIntakeMappedClient,
} from '@models/client-intake';
import type { ClientIntakeFormContextPathParams } from '../clientIntakeFormContext.firebase.repo';

export class SetClientIntakeFormContextConnection {
	static readonly type =
		'[Client Intake Form Context] Set client intake form context connection';
	constructor(
		public connect: boolean,
		public pathParams: ClientIntakeFormContextPathParams,
	) {}
}

export class ClearClientIntakeFormContextConnectionAndState {
	static readonly type =
		'[Client Intake Form Context] Clear client intake form context connection and state';
}

export class SetClientIntakeFormContext {
	static readonly type =
		'[Client Intake Form Context] Set client intake form context';
	constructor(public items: ClientIntakeFormContextItem[]) {}
}

export class UpsertClientIntakeFormContext {
	static readonly type =
		'[Client Intake Form Context] Upsert client intake form context';
	constructor(public items: ClientIntakeFormContextItem[]) {}
}

export class UpdateClientIntakeFormContextItem {
	static readonly type =
		'[Client Intake Form Context] Update client intake form context item';
	constructor(
		public itemId: string,
		public updates: Partial<ClientIntakeFormContextItem>,
	) {}
}

export class DeleteClientIntakeFormContextItem {
	static readonly type =
		'[Client Intake Form Context] Delete client intake form context item';
	constructor(public itemId: string) {}
}

export class AddClientsToIntakeFormContext {
	static readonly type = '[Client Intake Form Context] Add clients to context';
	constructor(public clients: ClientIntakeMappedClient[]) {}
}

export class RemoveClientsFromIntakeFormContext {
	static readonly type =
		'[Client Intake Form Context] Remove clients from context';
	constructor(public clients: ClientIntakeMappedClient[]) {}
}
